import * as storageKeys from '@/consts/app/storageKeys';
import {selectConsumerId} from '@/state/selectors/consumer';
import {getState} from '@/state/store';

import localStorageClient from './localStorageClient';
import sessionStorageClient from './sessionStorageClient';

const getConsumerItem = (key, isDecode) => {
    const consumerId = getConsumerId();
    const data = isDecode ? localStorageClient.getEncodedItem(key) : localStorageClient.getItem(key);

    return data?.[consumerId];
};
const setConsumerItem = (key, data, isEncode) => {
    const consumerId = getConsumerId();
    const dataFromStore = (isEncode ? localStorageClient.getEncodedItem(key) : localStorageClient.getItem(key)) || {};
    const newData = {...dataFromStore, ...{[consumerId]: data}};

    isEncode ? localStorageClient.setDecodedItem(key, newData) : localStorageClient.setItem(key, newData);
};

const getConsumerId = () => selectConsumerId(getState());

const getAppInstanceIdFromStorage = () => localStorageClient.getItem(storageKeys.APP_INSTANCE_ID);
const setAppInstanceIdToStorage = (data) => localStorageClient.setItem(storageKeys.APP_INSTANCE_ID, data);

const setAuthDataToStorage = (data) => localStorageClient.setDecodedItem(storageKeys.AUTH_DATA, data);
const removeAuthDataFromStorage = () => localStorageClient.removeItem(storageKeys.AUTH_DATA);
const getAuthDataFromStorage = () => localStorageClient.getEncodedItem(storageKeys.AUTH_DATA);

const setLanguageCodeToLocalStorage = (data) => localStorageClient.setDecodedItem(storageKeys.LANGUAGE_CODE, data);
const getLanguageCodeFromLocalStorage = () => localStorageClient.getEncodedItem(storageKeys.LANGUAGE_CODE);

const getFeedbackFromLocalStorage = () => localStorageClient.getItem(storageKeys.FEEDBACK);
const setFeedbackToLocalStorage = (data) => localStorageClient.setItem(storageKeys.FEEDBACK, data);

const getMissingDeviceNotificationDataFromLocalStorage = () =>
    localStorageClient.getItem(storageKeys.MISSING_DEVICE_NOTIFICATION);
const setMissingDeviceNotificationDataToLocalStorage = (data) =>
    localStorageClient.setItem(storageKeys.MISSING_DEVICE_NOTIFICATION, data);

const getSelectedDeviceCodentifyFromLocalStorage = () =>
    localStorageClient.getEncodedItem(storageKeys.SELECTED_DEVICE_CODENTIFY);
const setSelectedDeviceCodentifyToLocalStorage = (data) =>
    localStorageClient.setDecodedItem(storageKeys.SELECTED_DEVICE_CODENTIFY, data);

const getMarketCodeFromLocalStorage = () => localStorageClient.getItem(storageKeys.MARKET_CODE);
const setMarketCodeToLocalStorage = (data) => localStorageClient.setItem(storageKeys.MARKET_CODE, data);

const getHasSeenWelcomeScreen = () => getConsumerItem(storageKeys.HAS_SEEN_WELCOME_SCREEN, true);
const setHasSeenWelcomeScreen = () => setConsumerItem(storageKeys.HAS_SEEN_WELCOME_SCREEN, true, true);

const getIsGetStartedLanguageSelectDismissed = () =>
    sessionStorageClient.getItem(storageKeys.IS_GET_STARTED_LANGUAGE_SELECT_DISMISSED);
const setIsGetStartedLanguageSelectDismissed = (data) =>
    sessionStorageClient.setItem(storageKeys.IS_GET_STARTED_LANGUAGE_SELECT_DISMISSED, data);

const getIsAgeGateConfirmedFromStorage = () => localStorageClient.getItem(storageKeys.IS_AGE_CONFIRMED) === true;
const setIsAgeGateConfirmedToStorage = (data) => localStorageClient.setItem(storageKeys.IS_AGE_CONFIRMED, data);

const getAgeGateLockedUntilFromStorage = () => localStorageClient.getItem(storageKeys.AGE_GATE_LOCKED_UNTIL);
const setAgeGateLockedUntilToStorage = (timestamp) =>
    localStorageClient.setItem(storageKeys.AGE_GATE_LOCKED_UNTIL, timestamp);
const removeAgeGateLockedUntilFromStorage = () => localStorageClient.removeItem(storageKeys.AGE_GATE_LOCKED_UNTIL);

const setExpiringBadgeDataToLocalStorage = (data) => {
    setConsumerItem(storageKeys.EXPIRING_BADGE, data);
};
const getExpiringBadgeDataFromLocalStorage = () => {
    return getConsumerItem(storageKeys.EXPIRING_BADGE);
};

export default {
    setMarketCodeToLocalStorage,
    getMarketCodeFromLocalStorage,
    getAppInstanceIdFromStorage,
    getAuthDataFromStorage,
    getLanguageCodeFromLocalStorage,
    removeAuthDataFromStorage,
    setAppInstanceIdToStorage,
    setAuthDataToStorage,
    setLanguageCodeToLocalStorage,
    getFeedbackFromLocalStorage,
    setFeedbackToLocalStorage,
    getMissingDeviceNotificationDataFromLocalStorage,
    setMissingDeviceNotificationDataToLocalStorage,
    getSelectedDeviceCodentifyFromLocalStorage,
    setSelectedDeviceCodentifyToLocalStorage,
    getHasSeenWelcomeScreen,
    setHasSeenWelcomeScreen,
    getIsGetStartedLanguageSelectDismissed,
    setIsGetStartedLanguageSelectDismissed,
    getConsumerItem,
    setConsumerItem,
    getIsAgeGateConfirmedFromStorage,
    setIsAgeGateConfirmedToStorage,
    getAgeGateLockedUntilFromStorage,
    setAgeGateLockedUntilToStorage,
    removeAgeGateLockedUntilFromStorage,
    setExpiringBadgeDataToLocalStorage,
    getExpiringBadgeDataFromLocalStorage,
};
